<template>
  <div>
    <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
      <p class="text-muted mb-1 mb-md-0">
        Acompanhe a situação dos dispositivos e instale novos totens/painéis sem sair daqui.
      </p>
      <button type="button" class="btn btn-primary" @click="abrirModalInstalacao">
        <feather-icon icon="DownloadIcon" size="16" class="mr-50" />
        Instalar Novo Dispositivo
      </button>
    </div>

    <div class="row">
      <div class="col-md-4">
        <statistic-card-horizontal icon="ServerIcon" color="primary" :statistic="kpis.total"
          statisticTitle="Dispositivos Registrados" />
      </div>
      <div class="col-md-4">
        <statistic-card-horizontal icon="WifiIcon" color="success" :statistic="kpis.online"
          statisticTitle="Sincronizando" />
      </div>
      <div class="col-md-4">
        <statistic-card-horizontal icon="WifiOffIcon" color="danger" :statistic="kpis.offline"
          statisticTitle="Parados" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'devicesCrud'"
          crudName="Dispositivos"
          newText="Novo Dispositivo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :extra="extraButtons"
          :dataForm="dataForm"
          @enviarComando="abrirModalComando"
        >
          <div slot="situacao" slot-scope="props">
            <span v-if="online(props.row.ultima_sincronizacao)" class="badge badge-success">Online</span>
            <span v-else class="badge badge-danger">Offline</span>
          </div>
          <div slot="status" slot-scope="props">
            <span v-if="props.row.status == 1" class="badge badge-success">Ativo</span>
            <span v-else class="badge badge-secondary">Inativo</span>
          </div>
          <div slot="unidade" slot-scope="props">
            {{ props.row.unidade ? props.row.unidade.nome : "-" }}
          </div>
          <div slot="grupo" slot-scope="props">
            {{ props.row.grupo ? props.row.grupo.nome : "-" }}
          </div>
        </base-crud>
      </div>
    </div>

    <div
      class="modal fade"
      id="enviarComandoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Enviar Comando</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="comando">Comando:</label>
              <select v-model="comandoForm.comando" class="form-control" id="comando">
                <option value="reboot">Reiniciar (reboot)</option>
                <option value="shutdown">Desligar (shutdown)</option>
                <option value="restart_anydesk">Reiniciar AnyDesk</option>
                <option value="update_client">Atualizar Client</option>
                <option value="screenshot">Solicitar Print de Tela</option>
                <option value="custom">Comando Customizado</option>
              </select>
            </div>
            <div class="form-group" v-if="comandoForm.comando === 'custom'">
              <label for="payload">Comando a executar:</label>
              <textarea v-model="comandoForm.payload" class="form-control" id="payload" rows="3"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="enviarComando">
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="instalarDispositivoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Instalar Punhus Client</h5>
          </div>
          <div class="modal-body">
            <p>
              Rode o comando abaixo, como root, no dispositivo Ubuntu que você quer registrar.
              Ele instala as dependências, configura e inicia o client como serviço - sem
              precisar baixar nem editar nenhum arquivo manualmente.
            </p>
            <div class="form-group">
              <label for="comandoInstalacao">Comando de instalação:</label>
              <textarea
                id="comandoInstalacao"
                ref="comandoInstalacaoTextarea"
                class="form-control"
                rows="3"
                readonly
                :value="carregandoComandoInstalacao ? 'Gerando comando...' : comandoInstalacao"
                @click="$event.target.select()"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="carregandoComandoInstalacao || !comandoInstalacao"
              @click="copiarComandoInstalacao"
            >
              Copiar Comando
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import StatisticCardHorizontal from "../../@core/components/statistics-cards/StatisticCardHorizontal";

export default {
  data: function () {
    return {
      table: "devicesTable",
      devicesCrud: {},
      pages: [],
      url: "",
      kpis: {
        total: 0,
        online: 0,
        offline: 0,
      },
      kpiInterval: null,
      columns: ["id", "code", "title", "unidade", "grupo", "situacao", "ultima_sincronizacao", "ip_local", "id_anydesk", "status", "actions"],
      tableData: ["id", "code", "title", "unidade", "grupo", "situacao", "ultima_sincronizacao", "ip_local", "id_anydesk", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["title", "code", "ip_local", "id_anydesk", "status", "unidade", "grupo"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          code: "Código",
          title: "Título",
          unidade: "Unidade",
          grupo: "Grupo",
          situacao: "Situação",
          ultima_sincronizacao: "Última Sincronização",
          ip_local: "IP Local",
          id_anydesk: "AnyDesk ID",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            { id: 1, text: "Ativo" },
            { id: 0, text: "Inativo" },
          ],
          unidade: [],
          grupo: [],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["unidade", "grupo"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "devices/",
      dataForm: {},
      extraButtons: [
        {
          id: 1,
          title: "Enviar Comando",
          class: "btn btn-crud margin-crud",
          icon: "fa fa-terminal",
          label: "",
          name: "enviarComando",
        },
      ],
      comandoForm: {
        device_id: null,
        comando: "reboot",
        payload: "",
      },
      comandoInstalacao: "",
      carregandoComandoInstalacao: false,
    };
  },
  components: {
    BaseCrud,
    StatisticCardHorizontal,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        code: "code",
        title: "title",
        ip_local: "ip_local",
        id_anydesk: "id_anydesk",
        status: "status",
        unidade: "unidade_id",
        grupo: "grupo_id",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.options.listColumns.unidade = (response.data.data || []).map(
            (unidade) => ({ id: unidade.id, text: unidade.nome })
          );
        })
        .catch(() => {});
    },
    getGrupos: function () {
      const self = this;
      const api = self.$store.state.api + "grupos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.options.listColumns.grupo = (response.data.data || []).map(
            (grupo) => ({ id: grupo.id, text: grupo.nome })
          );
        })
        .catch(() => {});
    },
    online: function (ultimaSincronizacao) {
      if (!ultimaSincronizacao) {
        return false;
      }
      const ultima = new Date(ultimaSincronizacao.replace(" ", "T"));
      const diffMinutos = (Date.now() - ultima.getTime()) / 60000;
      return diffMinutos <= 2;
    },
    carregarKpis: function () {
      const self = this;
      const api = self.$store.state.api + "devices?paginated=false";

      axios
        .get(api)
        .then((response) => {
          const devices = response.data.data || [];
          const totalOnline = devices.filter((device) =>
            self.online(device.ultima_sincronizacao)
          ).length;

          self.kpis = {
            total: devices.length,
            online: totalOnline,
            offline: devices.length - totalOnline,
          };
        })
        .catch(() => {
          // KPI é informativo - não trava a tela se a busca falhar
        });
    },
    abrirModalComando: function (event) {
      this.comandoForm = {
        device_id: event.row.id,
        comando: "reboot",
        payload: "",
      };
      $("#enviarComandoModal").modal("show");
    },
    enviarComando: function () {
      const self = this;
      const api = self.$store.state.api + "comandos";

      axios
        .post(api, self.comandoForm)
        .then((response) => {
          $("#enviarComandoModal").modal("hide");
          self.$message("Sucesso", "Comando enfileirado com sucesso", "success");
          self.$refs.devicesCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    abrirModalInstalacao: function () {
      const self = this;
      const api = self.$store.state.api + "devices/comando-instalacao";

      self.comandoInstalacao = "";
      self.carregandoComandoInstalacao = true;
      $("#instalarDispositivoModal").modal("show");

      axios
        .get(api)
        .then((response) => {
          self.comandoInstalacao = response.data.comando;
        })
        .catch((error) => {
          $("#instalarDispositivoModal").modal("hide");
          self.$message(null, error.response.data, "error");
        })
        .finally(() => {
          self.carregandoComandoInstalacao = false;
        });
    },
    copiarComandoInstalacao: function () {
      const self = this;

      const copiar = navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard.writeText(self.comandoInstalacao)
        : new Promise((resolve, reject) => {
            const campo = self.$refs.comandoInstalacaoTextarea;
            campo.select();
            document.execCommand("copy") ? resolve() : reject();
          });

      copiar
        .then(() => self.$message("Sucesso", "Comando copiado para a área de transferência", "success"))
        .catch(() => self.$message(null, "Não foi possível copiar automaticamente - selecione o texto e copie manualmente", "error"));
    },
  },
  mounted: function () {
    const self = this;
    self.carregarKpis();
    self.getUnidades();
    self.getGrupos();
    self.kpiInterval = setInterval(self.carregarKpis, 30000);
  },
  beforeDestroy: function () {
    clearInterval(this.kpiInterval);
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
